/* eslint-disable jsx-a11y/prefer-tag-over-role */
import React, { useState } from 'react';
import { ChevronDownIcon } from './ChevronDown';
import { ChevronRightIcon } from './ChevronRight';
import { SecondaryGrid } from './SecondaryGrid';
import { TertiaryGrid } from './TertiaryGrid';
import { InfoIcon } from './InfoIcon';

export const MainGridRow = ({ row, rowIndex, onOpenModal, totalColumns, rowGridStyle }) => {
  const hasSecondaryGrid = row.secondaryGrid && row.secondaryGrid?.rows?.length > 0;
  const [isExpanded, setIsExpanded] = useState(hasSecondaryGrid);
  const hasTertiaryGrid = row.tertiaryGrid && row.tertiaryGrid?.rows?.length > 0;
  const isCollapsible = (hasSecondaryGrid && row.secondaryGrid.isCollapsible !== false) || (hasTertiaryGrid && row.tertiaryGrid.isCollapsible !== false);
  const PAST_DUE_MESSAGE = "A sample from this group was missed during a previous compliance cycle. To be current with monitoring requirements, the water system must collect the required number of sample(s) during the period shown in the ‘Next Sample Due’ field and submit the results to DDW.";
  const REPEAT_SAMPLE_MESSAGE = "For repeat samples, sample upstream, downstream, and at the original site.";

  const toggleExpand = (e) => {
      e.stopPropagation();
      if (isCollapsible) setIsExpanded(!isExpanded);
  };

  const getStatusClass = (text) => {
    if (!text) return '';
    const lowerText = String(text).toLowerCase();
    if (lowerText.includes('online')) return 'status-online';
    if (lowerText.includes('warning') || lowerText.includes('slow')) return 'status-warning';
    if (lowerText.includes('offline')) return 'status-offline';
    return '';
  };

  const isEvenRow = rowIndex % 2 === 0;
  const cellsToRender = row.cells.slice(0, totalColumns - 1);
  const detailsCell = row.cells[totalColumns - 1];

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */}
      <div 
        onClick={toggleExpand} 
        className={`grid-row ${isCollapsible ? 'clickable' : ''} ${isEvenRow ? 'is-even' : 'is-odd'}`}
        role="row"
        style={rowGridStyle}
      >
        {/* Render all data cells up to the Details column */}
        {cellsToRender.map((cell, index) => (
          <div key={index} className={`grid-cell ${getStatusClass(cell)}`} role="gridcell">
            {cell}
            {cell === 'Past Due' && (<button onClick={(e) => onOpenModal(e, "Past Due Sample", PAST_DUE_MESSAGE)} className="info-icon-button" aria-label="Past Due Sample information"><InfoIcon /></button>)}
            {(cell === 'RP' || cell === 'Repeat') && <button onClick={(e) => onOpenModal(e, "Repeat Sample Information", REPEAT_SAMPLE_MESSAGE)} className="info-icon-button" aria-label="Repeat Sample information"><InfoIcon /></button>}
          </div>
        ))}
        {/* Render the Details cell which may contain the expand/collapse control */}
        <div className={`grid-cell`} role="gridcell">
          {detailsCell}
          {isCollapsible && (
            /* eslint-disable-next-line jsx-a11y/control-has-associated-label */
            <button className="show-hide-row" onClick={toggleExpand} aria-expanded={isExpanded} aria-label={isExpanded ? 'Hide details' : 'Show details'}>
              <span className="visually-hidden">{isExpanded ? 'Hide details' : 'Show details'}</span>
              <span className='show-hide'>{isExpanded ? 'Hide' : 'Show'}&nbsp;</span>
              {isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
            </button>
          )}
        </div>
      </div>
      {(hasSecondaryGrid || hasTertiaryGrid) && (
        <div role="row" style={rowGridStyle}>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <div role="gridcell" aria-colspan={totalColumns} style={{ gridColumn: `1 / span ${totalColumns}` }} className={`expandable-container-secondary ${isEvenRow ? 'is-even' : 'is-odd'}`}>
            <div className={`expandable-content ${isExpanded ? 'expanded' : ''}`}> 
              {hasSecondaryGrid && (
                <div className="secondary-grid-wrapper">
                  <SecondaryGrid
                    headers={row.secondaryGrid.headers}
                    rows={row.secondaryGrid.rows}
                    onOpenModal={onOpenModal}
                  />
                </div>
              )}
              {hasTertiaryGrid && (
                <div className="tertiary-grid-wrapper">
                  <TertiaryGrid 
                    headers={row.tertiaryGrid.headers}
                    rows={row.tertiaryGrid.rows}
                    onOpenModal={onOpenModal}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
